import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IProductOption) {
    (function(IPrice) {
        IPrice.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IProductOption.IPrice || (IProductOption.IPrice = {}));
    (function(Type) {
        /**
     * The real ones, the token is a DbProductOption token (`po_`)
     */ Type["REGULAR"] = "REGULAR";
        /**
     * This was a product option, but has been converted to Mix&Match, and now has a `mmpo_` token.
     */ Type["MIX_AND_MATCH"] = "MIX_AND_MATCH";
        /**
     * A prepack might generate fake options to be purchased.
     * In this case, the token is from the underlying DbProductCollection (`pc_`)
     */ Type["PRE_PACK"] = "PRE_PACK";
        /**
     * This PO represents a DISPLAY, which is derived from DbProduct.Type.DISPLAY *
     */ Type["DISPLAY"] = "DISPLAY";
    })(IProductOption.Type || (IProductOption.Type = {}));
    (function(OrderabilityType) {
        OrderabilityType["ORDERABILITY_TYPE_UNKNOWN"] = "ORDERABILITY_TYPE_UNKNOWN";
        OrderabilityType["IMMEDIATE"] = "IMMEDIATE";
        OrderabilityType["PREORDER"] = "PREORDER";
    })(IProductOption.OrderabilityType || (IProductOption.OrderabilityType = {}));
    (function(ProductOptionLevelPrepackState) {
        ProductOptionLevelPrepackState["PRODUCT_OPTION_LEVEL_PREPACK_STATE_UNKNOWN"] = "PRODUCT_OPTION_LEVEL_PREPACK_STATE_UNKNOWN";
        /**
     * This product option is a product option level prepack
     */ ProductOptionLevelPrepackState["ACTIVE"] = "ACTIVE";
        /**
     * This product option is not a product option level prepack now, it used to be one
     */ ProductOptionLevelPrepackState["INACTIVE"] = "INACTIVE";
    })(IProductOption.ProductOptionLevelPrepackState || (IProductOption.ProductOptionLevelPrepackState = {}));
    IProductOption.build = function(partial) {
        return _object_spread({
            prices: [],
            images: [],
            variations: [],
            sizing_quantity: [],
            wholesale_price_by_quantity_list: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IProductOption || (IProductOption = {}));
export var IProductOption;
